"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _components = require("components");

var _glamor = require("glamor");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _config = require("../../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var planBox = function planBox(flag) {
  return (0, _glamor.css)(_css.dropShadow, {
    position: "relative",
    minWidth: flag ? 310 : "unset"
  }, (0, _polyfluid.polyfluid)({
    fontSize: {
      small: 1,
      medium: 0.75,
      large: [0.75, 1]
    }
  }), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
    maxWidth: "310px",
    margin: "auto"
  }));
};

var planBoxInner = function planBoxInner(height) {
  return (0, _glamor.css)({
    height: (0, _css.unitRem)(18),
    padding: "4em",
    textAlign: "left",
    background: _css.colors.medDarkGray2,
    borderRadius: "6px"
  }, (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
    padding: "2rem"
  }), (0, _css.maxWidth)("75em")({
    padding: "2em",
    paddingTop: "2.5rem"
  }), (0, _css.maxWidth)(_css.breakpoints.medium)({
    height: "auto",
    padding: "2em"
  }), (0, _polyfluid.polyfluid)({
    height: {
      medium: [24 + height],
      large: [24 + height]
    }
  }));
};

var topBar = function topBar(color) {
  return (0, _glamor.css)({
    display: "block",
    position: "relative",

    height: 2,
    marginBottom: (0, _css.unitRem)(0.7),

    background: _ramda2.default.cond([[_ramda2.default.equals("green"), _ramda2.default.always(_css.gradients.green)], [_ramda2.default.equals("blue"), _ramda2.default.always(_css.gradients.blue)], [_ramda2.default.equals("gray"), _ramda2.default.always(_css.gradients.gray)], [_ramda2.default.equals("yellow"), _ramda2.default.always(_css.gradients.yellow)]])(color)
  });
};

var details = (0, _glamor.css)({
  marginBottom: "2em"
});

var name = function name(logo) {
  return (0, _glamor.css)(_fonts.subH7, {
    fontFamily: "Open Sans Condensed",
    textTransform: "uppercase",
    fontWeight: 700,
    lineHeight: "0.9",
    display: "block",
    whiteSpace: "nowrap",
    color: _css.colors.white,
    marginLeft: logo ? "1.1875rem" : "0"
  }, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
    lineHeight: "1.3"
  }));
};

var desc = (0, _glamor.css)(_fonts.p4, {
  display: "block",
  color: _css.pallets.white,
  position: "absolute",
  paddingRight: "2.9rem"
});

var subDesc = (0, _glamor.css)(_fonts.p4, {
  display: "block",
  color: _css.pallets.gray_text,
  position: "absolute",
  paddingRight: "2.9rem",
  fontSize: "14px",
  marginTop: "0.9rem"
});

var price = (0, _glamor.css)({
  display: "block",
  color: _css.colors.white,
  fontWeight: 400,
  marginTop: "9.2rem",
  "& .price-from": {
    fontSize: "1.125rem",
    color: _css.pallets.gray_text,
    letterSpacing: -0.5,
    fontWeight: 400
  },
  "& .price-decimal": {
    fontSize: "2.125em",
    marginRight: 6,
    color: _css.colors.white,
    position: "absolute",
    left: "57%",
    top: "18%"
  },

  "& .price-value": {
    letterSpacing: -0.5,
    fontFamily: "Open Sans Condensed",

    fontSize: "3rem",
    fontWeight: 700,
    marginLeft: (0, _css.unitRem)(0.1)
  },
  "& .price-value-wrap": {
    marginBottom: "0.5em"
  }
});

var contactUs = (0, _glamor.css)(_fonts.p4, {
  display: "block",
  color: _css.colors.gray,
  marginTop: "14.45rem",
  lineHeight: 1.33,
  fontFamily: '"Source Sans Pro", sans-serif'
}, (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  marginTop: "14.45rem"
}));

var _buttonWrap = (0, _glamor.css)({
  textAlign: "center",
  width: "100%",
  marginTop: "1.875rem"
});

var button = (0, _glamor.css)({
  display: "block",
  width: "100%",
  fontWeight: 700,
  background: "none",
  "& button": {
    padding: "1.1em 0",
    minWidth: "210px",
    width: "100%",
    fontWeight: 700
  },
  "& a": {
    minWidth: "192px",
    width: "100%",
    fontWeight: 700
  }
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  "& button": {
    padding: "1.1em 0",
    minWidth: "192px!important"
  },
  "& a": {
    minWidth: "192px"
  }
}), (0, _css.minWidth)(_css.breakpoints.medium)({
  "& button": {
    padding: "1.1em 0",
    minWidth: "85%!important"
  },
  "& a": {
    minWidth: "85%!important"
  }
}), (0, _css.minWidth)(_css.breakpoints.xxxlarge)({
  "& button": {
    padding: "1.1em 0",
    minWidth: "85%!important",
    width: "85%!important"
  },
  "& a": {
    minWidth: "85%!important",
    width: "85%!important"
  }
}));

var borderButton = (0, _glamor.css)({
  "& button": {
    background: "none",
    border: "2px solid #26BBFF",
    color: "#26BBFF"
  },
  "& a": {
    background: "none",
    border: "2px solid #26BBFF",
    color: "#26BBFF"
  }
});

var link = (0, _glamor.css)({
  textAlign: "left",
  "& div": {
    textAlign: "left"
  },
  "& button": {
    fontWeight: 700,
    textAlign: "left",
    width: "unset",
    paddingLeft: 0,
    paddingRight: 3
  },
  "& a": {
    fontWeight: 700,
    textAlign: "left",
    width: "unset",
    paddingLeft: 0,
    paddingRight: 3
  }
});

var logo = function logo(img) {
  return (0, _glamor.css)((0, _css.bgContain)(img), {
    width: "48px",
    height: "48px",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    opacity: 1
  });
};

var humanizePrice = function humanizePrice(p) {
  return "" + p;
};

var buttonMode = _ramda2.default.cond([[_ramda2.default.equals("green"), _ramda2.default.always("primary")], [_ramda2.default.equals("blue"), _ramda2.default.always("secondary")], [_ramda2.default.equals("gray"), _ramda2.default.always("tertiary")], [_ramda2.default.equals("yellow"), _ramda2.default.always("yellow")]]);

var listWrapper = (0, _glamor.css)({
  display: "flex",
  flexDirection: "column",
  marginTop: "3.5rem"
});

var list = (0, _glamor.css)({
  display: "flex",
  justifyContent: "flex-start",
  alignItem: "center",
  marginLeft: "0.5rem"
});

var grayContent = (0, _glamor.css)({
  width: "80%",
  color: _css.pallets.gray_text,
  marginTop: "-6px"
});

var image = function image(flag) {
  return (0, _glamor.css)({
    width: "24px",
    height: "24px",
    marginRight: "19px",
    visibility: flag ? "visible" : "hidden"
  });
};

var QuixelContactUsFormLink = "https://forms.unrealengine.com/s/quixel-contact-us?language=en_US&token=96ILllk3rAwGSKUIhAE950LuKbmWjbuvdWNs";

var isFreePlan = function isFreePlan(name) {
  return ["personal", "indie"].includes(name.toLowerCase());
};

var PlanBox = function PlanBox(props) {
  var isStudioUser = props.subscription && props.subscription.planId === "studio";

  return _react2.default.createElement(
    "div",
    planBox(false),
    _react2.default.createElement(
      "div",
      planBoxInner(props.marketingPoints ? props.marketingPoints.length * 2.4 : 2.4 * 3),
      _react2.default.createElement(
        "div",
        details,
        _react2.default.createElement(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              marginBottom: "1.2rem"
            } },
          props.logo && _react2.default.createElement("span", { className: logo(props.logo) }),
          _react2.default.createElement(
            "span",
            name(props.logo),
            props.name
          )
        ),
        props.barColor && _react2.default.createElement("span", topBar(props.barColor)),
        _react2.default.createElement(
          "span",
          desc,
          props.desc
        )
      ),
      _react2.default.createElement(
        "div",
        { className: listWrapper },
        props.marketingPoints && props.marketingPoints.map(function (point, i) {
          return _react2.default.createElement(
            "div",
            { key: i, className: list },
            point.logo && _react2.default.createElement("img", { className: image(point.logo), src: point.logo, alt: "" }),
            _react2.default.createElement(
              "span",
              null,
              _react2.default.createElement(
                "svg",
                {
                  width: "13",
                  height: "10",
                  viewBox: "0 0 13 10",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg" },
                _react2.default.createElement("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M12.4939 0.435578C12.8056 0.708339 12.8372 1.18216 12.5644 1.49389L5.56443 9.49389C5.42774 9.65011 5.23242 9.74269 5.02496 9.74959C4.8175 9.7565 4.61645 9.67712 4.46967 9.53034L0.46967 5.53034C0.176777 5.23745 0.176777 4.76257 0.46967 4.46968C0.762563 4.17679 1.23744 4.17679 1.53033 4.46968L4.96347 7.90282L11.4356 0.506132C11.7083 0.194404 12.1822 0.162816 12.4939 0.435578Z",
                  fill: "#26BBFF"
                })
              ),
              point.check && _react2.default.createElement("span", {
                className: (0, _glamor.css)(_fonts.p4, { marginLeft: "0.5rem" }),
                dangerouslySetInnerHTML: { __html: point.check } }),
              point.desc && _react2.default.createElement("span", { className: _fonts.p4, dangerouslySetInnerHTML: { __html: point.desc } }),
              point.gray && _react2.default.createElement("span", {
                className: (0, _glamor.css)(_fonts.p4, grayContent),
                dangerouslySetInnerHTML: { __html: point.gray } }),
              point.li && _react2.default.createElement("span", {
                className: (0, _glamor.css)(_fonts.p4, { display: "list-item" }),
                dangerouslySetInnerHTML: { __html: point.li }
              }),
              point.green && _react2.default.createElement(
                "ol",
                {
                  className: (0, _glamor.css)(_fonts.p4, {
                    listStyle: "none",
                    counterReset: "item"
                  }) },
                _react2.default.createElement("li", {
                  className: (0, _glamor.css)({
                    color: "#95d34d",
                    marginLeft: "1.3rem",
                    counterIncrement: "item",
                    ":before": {
                      position: "absolute",
                      left: "3.1rem",
                      content: 'counter(item, cjk-ideographic) " "'
                    }
                  }),
                  dangerouslySetInnerHTML: { __html: point.green }
                })
              )
            )
          );
        })
      ),
      props.subDesc && _react2.default.createElement(
        "span",
        subDesc,
        props.subDesc
      ),
      !props.hidePrice ? _react2.default.createElement(
        "div",
        price,
        _react2.default.createElement(
          "div",
          { className: "price-value-wrap" },
          props.hasMonetizationStopped && isFreePlan(props.name) && _react2.default.createElement(
            "div",
            { style: { marginTop: -24, fontSize: 16, color: "#808080", lineHeight: "24px" } },
            _react2.default.createElement(
              "s",
              null,
              "$",
              props.price,
              "/month"
            )
          ),
          !props.noPrice ? _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "span",
              { className: "price-value" },
              "$",
              humanizePrice(!!props.pointsPerYear && props.name === "Business" ? parseInt(parseInt(props.price) / 12) : props.price)
            ),
            _react2.default.createElement(
              "span",
              { className: "price-from" },
              "/ month *"
            )
          ) : _react2.default.createElement(
            "span",
            { className: "price-value" },
            "FREE"
          )
        )
      ) : _react2.default.createElement(
        "div",
        price,
        props.contactUsDescription ? _react2.default.createElement(
          "span",
          contactUs,
          props.contactUsDescription
        ) : _react2.default.createElement(
          "span",
          contactUs,
          "Contact us for custom pricing"
        )
      ),
      _react2.default.createElement(
        "div",
        {
          className: (0, _glamor.css)(_buttonWrap, {
            textAlign: props.subscribed ? "left" : "center",
            display: props.subscribed ? "flex" : "block"
          }) },

        // eslint-disable-next-line no-nested-ternary
        props.upgrade ? _react2.default.createElement(_components.TextButtonLibrary, {
          className: link,
          mode: "small",
          label: "Switch to Annual",
          onClick: props.onUpgradeSubscriptionClick
        }) : props.isCurrentPlan ? _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.TextButtonLibrary, {
            className: link,
            mode: "small-gray",
            label: "MY PLAN",
            isDisabled: true
          }),
          _react2.default.createElement(_components.TextButtonLibrary, {
            className: link,
            mode: "small",
            to: "library/account",
            label: "- MANAGE ACCOUNT"
          })
        ) : props.subscribed ? _react2.default.createElement(_components.TextButtonLibrary, {
          className: link,
          mode: "small",
          label: props.buttonLearnMoreLabel ? props.buttonLearnMoreLabel : "LEARN MORE",
          onClick: function onClick() {
            if (isStudioUser) {
              window.open(QuixelContactUsFormLink, "_blank");
            } else {
              window.open(props.name === "Studio" ? QuixelContactUsFormLink : _config2.default.forumBaseUrl, "_blank");
            }
          }
        }) : props.contactUs ? _react2.default.createElement(_Button2.default, {
          className: (0, _glamor.css)(button, borderButton),
          mode: "secondary",
          label: props.buttonContactUsLearnMoreLabel ? props.buttonContactUsLearnMoreLabel : "LEARN MORE",
          onClick: function onClick() {
            if (isStudioUser) {
              window.open(QuixelContactUsFormLink, "_blank");
            } else {
              window.open(props.name === "Studio" ? QuixelContactUsFormLink : _config2.default.forumBaseUrl, "_blank");
            }
          }
        }) : _react2.default.createElement(_Button2.default, {
          className: (0, _glamor.css)(button, props.borderButton && borderButton),
          mode: buttonMode(props.buttonColor),
          label: props.buttonSubscribeLabel ? props.buttonSubscribeLabel : "SUBSCRIBE",
          to: props.hasMonetizationStopped ? undefined : props.selectTo,
          onClick: function onClick() {
            props.hasMonetizationStopped && isFreePlan(props.name) ? props.openFreeSubscriptionPopup(props.name) : props.initializePayment();
          }
        })
      )
    )
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth,
    hasMonetizationStopped: state.eol.hasMonetizationStopped
  };
})((0, _reactRouter.withRouter)(PlanBox));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Marketing/PlanBox/index.jsx
// module id = 2582
// module chunks = 0